// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileDropzone_orderModal__G\\+LCe {
  padding: 0;
}
.FileDropzone_orderModal__G\\+LCe .modal__inner {
  border-radius: 0;
  max-width: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.FileDropzone_orderModal__G\\+LCe .modal__inner .modal__header {
  padding: 24px 16px;
  border: none;
}
.FileDropzone_orderModal__G\\+LCe .modal__inner .modal__body {
  background: #FFF;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 0;
}
.FileDropzone_orderModal__G\\+LCe .modal__inner .modal__body .submitBlock {
  margin-top: auto;
}
.FileDropzone_orderModal__G\\+LCe .options-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 1200px) {
  .FileDropzone_orderModal__G\\+LCe .options-list {
    gap: 24px;
  }
}
.FileDropzone_orderModal__G\\+LCe .checkbox-row p, .FileDropzone_orderModal__G\\+LCe .radio-row p {
  line-height: 114%;
  border: none;
}
.FileDropzone_orderModal__G\\+LCe .FileDropzone_modal-text__HsFjP {
  font-size: 14px;
  line-height: 20px;
  color: #54575C;
}
.FileDropzone_orderModal__swipeHandler__0jG38 {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.FileDropzone_orderModal__swipeHandler__0jG38 span {
  border-radius: 8px;
  background: #FFF;
  width: 88px;
  height: 2px;
  z-index: 2;
  display: block;
  position: relative;
}
.FileDropzone_orderModal__swipeHandler__0jG38::before {
  content: "";
  position: absolute;
  bottom: -5vh;
  left: 0;
  right: 0;
  width: 100%;
  height: 30vh;
  background: transparent;
}
.FileDropzone_orderModal__top__n38Ki {
  width: 100%;
  min-height: 216px;
  height: 55vw;
  max-height: 420px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}
.FileDropzone_orderModal__top__n38Ki .swiper {
  height: 100%;
}
.FileDropzone_orderModal__top__n38Ki .swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  margin: 0 6px;
  background: #D9D9D9;
  opacity: 0.4;
}
.FileDropzone_orderModal__top__n38Ki .swiper-pagination-bullet-active {
  background: #FAFAFA;
  opacity: 1;
}
.FileDropzone_orderModal__top__n38Ki .swiper-slide {
  width: 100%;
}
.FileDropzone_orderModal__top__n38Ki .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.FileDropzone_orderModal__roundedTop__svAsM {
  border-radius: 16px 16px 0 0;
}
.FileDropzone_orderModal__body__Unjg7 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px 16px 0 0;
  padding: 0 16px;
}
.FileDropzone_orderModal__body_load__v38gi {
  gap: initial;
}
.FileDropzone_orderModal__block__Xi6Ht {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 5px;
}
@media (min-width: 1200px) {
  .FileDropzone_orderModal__block__Xi6Ht {
    margin-bottom: 24px;
  }
}
.FileDropzone_orderModal__blockTitle__SZUzg {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  padding-bottom: 4px;
}
@media (min-width: 640px) {
  .FileDropzone_orderModal__blockTitle__SZUzg {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .FileDropzone_orderModal__blockTitle__SZUzg {
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
  }
}
.FileDropzone_orderModal__blockTitle__SZUzg::first-letter {
  text-transform: capitalize;
}
.FileDropzone_orderModal__blockRequired__6gUgW {
  color: #f2200d;
}
.FileDropzone_orderModal__submitBlock__6JHiY {
  padding: 16px;
  bottom: -1px;
  left: 50%;
  background: #FFF;
  z-index: 2;
  position: sticky;
  width: 100%;
}
.FileDropzone_orderModal__submitBlockHead__CjzUd {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.FileDropzone_orderModal__submitBlockHead__CjzUd h5 {
  color: #151B26;
  line-height: 114%;
  font-size: 14px;
  font-weight: 600;
}
.FileDropzone_orderModal__submitBlockHead__CjzUd p {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 114%;
  letter-spacing: -0.24px;
}
.FileDropzone_orderModal__submitBlockBottom__VP6KD {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.FileDropzone_orderModal__calc__AgiV0 {
  height: 44px;
  width: 88px;
  min-width: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #EEE;
  margin-right: 12px;
}
.FileDropzone_orderModal__calcPlus__M0\\+Om, .FileDropzone_orderModal__calcMinus__oY4XJ {
  width: 16px;
  height: 20px;
  display: flex;
  align-items: center;
}
.FileDropzone_orderModal__calcPlus__M0\\+Om:disabled, .FileDropzone_orderModal__calcMinus__oY4XJ:disabled {
  opacity: 0.5;
}
.FileDropzone_orderModal__calcNum__KAa\\+D {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #000;
  width: 32px;
  margin: 0 4px;
  text-align: center;
}
.FileDropzone_orderModal__picker__er0sV {
  width: 100%;
  position: relative;
}
.FileDropzone_orderModal__picker__er0sV img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  pointer-events: none;
}
@media (min-width: 640px) {
  .FileDropzone_orderModal__picker__er0sV img {
    right: 20px;
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 1200px) {
  .FileDropzone_orderModal__picker__er0sV img {
    width: 22px;
    height: 22px;
    right: 10px;
  }
}
.FileDropzone_orderModal__picker__er0sV input[type=date]:not(.FileDropzone_has_value__6CTbY)::-webkit-datetime-edit-fields-wrapper,
.FileDropzone_orderModal__picker__er0sV input[type=datetime-local]:not(.FileDropzone_has_value__6CTbY)::-webkit-datetime-edit-fields-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.FileDropzone_orderModal__picker__er0sV input[type=date]::-webkit-inner-spin-button,
.FileDropzone_orderModal__picker__er0sV input[type=datetime-local]::-webkit-inner-spin-button,
.FileDropzone_orderModal__picker__er0sV input[type=date]::-webkit-calendar-picker-indicator,
.FileDropzone_orderModal__picker__er0sV input[type=datetime-local]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.FileDropzone_orderModal__picker__er0sV input[type=date], .FileDropzone_orderModal__picker__er0sV input[type=datetime-local] {
  -webkit-appearance: none;
  width: -webkit-fill-available;
}
.FileDropzone_orderModal__picker__er0sV input[type=date]:not(.FileDropzone_has_value__6CTbY):before,
.FileDropzone_orderModal__picker__er0sV input[type=datetime-local]:not(.FileDropzone_has_value__6CTbY):before {
  content: attr(placeholder);
  color: #BEC0C2;
  width: 100%;
}
.FileDropzone_orderModal__picker__er0sV input[type=date]::after,
.FileDropzone_orderModal__picker__er0sV input[type=datetime-local]::after {
  position: absolute;
  right: 0;
  content: "";
  width: 20px;
  height: 100%;
  background: white;
  border-radius: 8px;
}
.FileDropzone_orderModal__picker__er0sV input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #E8ECEE;
  background: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 3px 10px;
  position: relative;
}
@media (min-width: 640px) {
  .FileDropzone_orderModal__picker__er0sV input {
    height: 64px;
    padding-left: 32px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .FileDropzone_orderModal__picker__er0sV input {
    height: 38px;
    padding-left: 10px;
    font-size: var(--fz-md);
    line-height: normal;
  }
}
.FileDropzone_orderModal__picker__er0sV input::placeholder {
  color: #BEC0C2;
}
.FileDropzone_orderModal__picker__er0sV .react-datepicker-wrapper {
  width: 100%;
}
.FileDropzone_orderModal__sk1__P1ht4, .FileDropzone_orderModal__sk2__AIszX, .FileDropzone_orderModal__sk3__UOVJm, .FileDropzone_orderModal__sk4__fDmeU {
  border-radius: 2px;
  height: 13px;
  width: 100%;
  margin-top: 8px;
}
.FileDropzone_orderModal__sk2__AIszX {
  width: 85%;
  margin-top: 10px;
}
.FileDropzone_orderModal__sk3__UOVJm {
  width: 50%;
  margin-top: 10px;
}
.FileDropzone_orderModal__sk4__fDmeU {
  width: 20%;
  margin-top: 16px;
  margin-bottom: 9px;
}
.FileDropzone_orderModal__sk5__IMPO0 {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 4px;
  padding-top: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F3F2F2;
}
.FileDropzone_orderModal__sk5__IMPO0 span {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: block;
  margin-top: 4px;
  margin-bottom: 4px;
}
.FileDropzone_orderModal__sk5__IMPO0 div {
  border-radius: 2px;
  height: 14px;
  width: calc(100% - 34px);
}
.FileDropzone_orderModal__info__99NRu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.FileDropzone_orderModal__infoTitle__ep0eT {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  color: var(--text-color);
}
.FileDropzone_orderModal__infoText__hhRbt {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  word-wrap: break-word;
}
.FileDropzone_orderModal__infoText__hhRbt a {
  color: var(--accent-color);
  text-decoration: underline;
}
.FileDropzone_orderModal__infoText__hhRbt ul, .FileDropzone_orderModal__infoText__hhRbt ol {
  margin: 0;
  padding: 0;
  padding-left: 16px;
}
.FileDropzone_orderModal__infoText__hhRbt img {
  max-width: 100%;
}
.FileDropzone_orderModal__infoText__hhRbt table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.FileDropzone_orderModal__infoText__hhRbt table td, .FileDropzone_orderModal__infoText__hhRbt table th {
  min-width: 1em;
  border: 2px solid #ced4da;
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
.FileDropzone_orderModal__infoText__hhRbt table td > *, .FileDropzone_orderModal__infoText__hhRbt table th > * {
  margin-bottom: 0;
}
.FileDropzone_orderModal__infoText__hhRbt table th {
  font-weight: 700;
  text-align: left;
  background-color: #f1f3f5;
}
.FileDropzone_orderModal__infoText__hhRbt p {
  min-height: 20px;
}
.FileDropzone_orderModal__infoText__hhRbt h1, .FileDropzone_orderModal__infoText__hhRbt h2, .FileDropzone_orderModal__infoText__hhRbt h3 {
  color: #303030;
}
.FileDropzone_orderModal__infoText__hhRbt pre {
  background: #2b2a2a;
  color: #fff;
  padding: 8px;
  display: flex;
  border-radius: 8px;
  width: 100%;
  white-space: pre-wrap;
}
.FileDropzone_orderModal__infoText__hhRbt code {
  width: 100%;
  display: block;
  color: #fff;
  background-color: #f1f3f5;
}
.FileDropzone_orderModal__files__ykQop {
  padding-top: 8px;
}
.FileDropzone_orderModal__files__ykQop .orderModal__file {
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 8px 32px 8px 4px;
  border-radius: 12px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: var(--transition);
  margin-bottom: 8px;
}
.FileDropzone_orderModal__files__ykQop .orderModal__file img {
  width: 15px;
  height: 21px;
}
.FileDropzone_orderModal__file__IZTOX {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 8px;
  padding: 8px 32px 8px 4px;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid transparent;
  position: relative;
  transition: var(--transition);
}
@media (hover: hover) {
  .FileDropzone_orderModal__file__IZTOX:hover {
    border-color: var(--accent-color);
  }
}
.FileDropzone_orderModal__fileContent__CubJ8 {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: var(--transition);
}
.FileDropzone_orderModal__fileContent__CubJ8 img {
  max-width: 24px;
  min-width: 24px;
}
.FileDropzone_orderModal__fileIsLoading__loader__8xxOk {
  height: 3px;
  background: #4084F8;
}
.FileDropzone_orderModal__fileName__N4Co4 {
  font-size: var(--fz-md);
  line-height: var(--lh-md);
}
.FileDropzone_orderModal__fileSize__u\\+7-m {
  font-size: var(--fz-sm);
  line-height: 1;
  color: #7A808B;
  margin-top: 2px;
}
.FileDropzone_orderModal__fileDelete__G0yhs {
  margin-left: auto;
  color: var(--error);
}
.FileDropzone_orderModal__object__Bzw9F {
  border-radius: 12px;
  background: #FAFAFA;
  padding: 8px;
  display: flex;
  align-items: center;
}
.FileDropzone_orderModal__objectIco__mTs2F {
  width: 26px;
  min-width: 26px;
  height: 26px;
  margin-right: 8px;
}
.FileDropzone_orderModal__objectText__nbCWv span {
  font-size: 14px;
  line-height: 114%;
  color: #7A808B;
}
.FileDropzone_orderModal__objectText__nbCWv p {
  font-size: 16px;
  color: #101618;
  line-height: 23.04px;
}
.FileDropzone_orderModal__objectArrow__X5W2r {
  margin-left: auto;
}
@media (min-width: 640px) {
  .FileDropzone_orderModal__top__n38Ki .swiper-pagination {
    bottom: 24px;
  }
  .FileDropzone_orderModal__top__n38Ki .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    margin: 0 12px;
    background: #D9D9D9;
    opacity: 0.4;
  }
  .FileDropzone_orderModal__top__n38Ki .swiper-pagination-bullet-active {
    background: #FAFAFA;
    opacity: 1;
  }
  .FileDropzone_orderModal__body__Unjg7 {
    padding: 16px 24px 0;
  }
  .FileDropzone_orderModal__submitBlock__6JHiY {
    padding: 24px;
    margin-left: -24px;
  }
  .FileDropzone_orderModal__submitBlockHead__CjzUd h5 {
    font-size: 32px;
  }
  .FileDropzone_orderModal__submitBlockHead__CjzUd p {
    font-size: 28px;
    letter-spacing: -0.56px;
  }
  .FileDropzone_orderModal__submitBlockBottom__VP6KD {
    margin-top: 18px;
  }
  .FileDropzone_orderModal__calc__AgiV0 {
    border-radius: 16px;
    width: 195px;
    min-width: 195px;
    height: 76px;
    margin-right: 16px;
  }
  .FileDropzone_orderModal__calcNum__KAa\\+D {
    width: 59px;
    height: 22px;
    margin: 0 16px;
    font-size: 28px;
  }
  .FileDropzone_orderModal__calcPlus__M0\\+Om, .FileDropzone_orderModal__calcMinus__oY4XJ {
    width: 32px;
    height: 32px;
  }
  .FileDropzone_orderModal__calcPlus__M0\\+Om svg, .FileDropzone_orderModal__calcMinus__oY4XJ svg {
    width: 32px;
    height: 32px;
  }
}
.FileDropzone_orderModal__inputError__JXW4v.FileDropzone_orderModal__inputError__JXW4v {
  border-color: #F2200D;
}
.FileDropzone_orderModal__time__fCEw7 {
  font-size: 12px;
  padding: 2px 4px;
  min-height: auto;
}

.FileDropzone_photoBlock__\\+APaP {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(3, 1fr);
  position: relative;
}
@media (min-width: 1200px) {
  .FileDropzone_photoBlock__\\+APaP {
    grid-template-columns: repeat(6, 1fr);
  }
}
.FileDropzone_photoBlock__append__shBAv {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 105px;
  cursor: pointer;
  background: rgba(var(--accent-color-rgb), 0.1);
}
.FileDropzone_photoBlock__append__shBAv.FileDropzone_error__qAZKX {
  border: 1px solid #F2200D;
}
.FileDropzone_photoBlock__plus__yTF4O {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent-color);
  color: var(--accent-text-color);
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.FileDropzone_photoBlock__preview__oGY-g {
  height: 105px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.FileDropzone_photoBlock__preview__oGY-g > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.FileDropzone_photoBlock__close__Q8jY- {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: #E97676;
}
@media (min-width: 640px) {
  .FileDropzone_photoBlock__append__shBAv, .FileDropzone_photoBlock__preview__oGY-g {
    height: 140px;
  }
}
@media (min-width: 1200px) {
  .FileDropzone_photoBlock__append__shBAv, .FileDropzone_photoBlock__preview__oGY-g {
    height: 104px;
  }
}
.FileDropzone_photoBlock__camera__MlRXJ {
  color: rgba(var(--accent-color-rgb), 0.45);
}
.FileDropzone_photoBlock__error__G4eGh {
  position: initial !important;
  justify-content: flex-start !important;
}
.FileDropzone_photoBlock__loader__DRSg\\+ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.FileDropzone_photoBlock__loader__precent__c4k9o {
  color: white;
  font-weight: 600;
  font-size: 12px;
  z-index: 1;
}
.FileDropzone_photoBlock__loader__overlay__vRbP7 {
  position: absolute;
  background: rgba(178, 178, 178, 0.6784313725);
  width: 100%;
  height: 100%;
  top: 0;
}
.FileDropzone_photoBlock__compressBlock__ov0nA {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
}
.FileDropzone_photoBlock__compressBlock__ov0nA svg {
  width: 24px;
  fill: none;
  animation-name: FileDropzone_grow__kkSg9;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.FileDropzone_photoBlock__compressBlock__ov0nA svg path {
  stroke: white;
}
.FileDropzone_photoBlock__compressLoading__z-ZiA {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 3;
}
.FileDropzone_photoBlock__compressLoading__z-ZiA svg {
  width: 24px;
  fill: none;
  animation-name: FileDropzone_grow__kkSg9;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.FileDropzone_photoBlock__compressLoading__z-ZiA svg path {
  stroke: black;
}

@keyframes FileDropzone_grow__kkSg9 {
  0% {
    scale: 1;
  }
  50% {
    scale: 2;
  }
  100% {
    scale: 1;
  }
}
@media (min-width: 1200px) {
  label.FileDropzone_checkboxAlone__dxA8B {
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  label.FileDropzone_checkboxAlone__dxA8B p {
    width: auto;
    font-weight: 500;
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
    padding-top: 5px;
    margin-right: 8px;
  }
}

@media (min-width: 1200px) {
  .FileDropzone_orderModal__block__Xi6Ht .FileDropzone_checkboxAlone__dxA8B p:last-child {
    margin-left: 0;
  }
}

.FileDropzone_conditionList__2AeRA {
  position: initial;
  overflow: hidden;
  transition: 0.15s;
}

.FileDropzone_conditionList__container__O38hp {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1200px) {
  .FileDropzone_conditionList__container__O38hp {
    gap: 24px;
  }
}

.FileDropzone_qrWrapBlock__-RSlE {
  position: relative;
}
.FileDropzone_qrWrapBlock__-RSlE .FileDropzone_qrWrapBlock__error__8kcQT {
  position: relative;
  justify-content: flex-start;
  margin: 0;
}
@media (min-width: 1200px) {
  .FileDropzone_qrWrapBlock__-RSlE .FileDropzone_qrWrapBlock__error__8kcQT {
    position: absolute;
    top: 100%;
    left: 0;
    justify-content: flex-start;
    margin: 0;
  }
}

.FileDropzone_qrBlock__Uew\\+L {
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #EAF7EF;
  width: max-content;
  cursor: pointer;
}
.FileDropzone_qrBlock--error__-uN80 {
  color: var(--red);
}
.FileDropzone_qrBlock__Uew\\+L svg {
  width: 13px;
  height: 13px;
}
.FileDropzone_qrBlock__Uew\\+L svg path {
  fill: #2DBE64;
}

.FileDropzone_QRInput__VlEEA {
  position: relative;
}
.FileDropzone_QRInput__VlEEA input:disabled {
  background: none;
}
.FileDropzone_QRInput__icon__S2e4i {
  position: absolute;
  top: calc(50% - 16px);
  right: 10px;
  background: none;
}

.FileDropzone_fileDropzone__0XYHQ {
  position: relative;
}
.FileDropzone_fileDropzone__append__QvP1E {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  font-size: var(--fz-md);
  font-style: normal;
  font-weight: 400;
  line-height: var(--lh-md);
  color: #000;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: rgba(var(--accent-color-rgb), 0.1);
  cursor: pointer;
  transition: var(--transition);
  min-height: 40px;
}
@media (hover: hover) {
  .FileDropzone_fileDropzone__append__QvP1E:hover {
    border-color: var(--accent-color);
  }
}
.FileDropzone_fileDropzone__append__QvP1E.FileDropzone_error__qAZKX {
  border-color: #F2200D;
}
.FileDropzone_fileDropzone__delete__UKrh0 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 14px;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ABB8C8;
  transition: var(--transition);
}
@media (hover: hover) {
  .FileDropzone_fileDropzone__delete__UKrh0:hover {
    color: var(--error);
  }
}
.FileDropzone_fileDropzone__plus__CoCc9 {
  flex-shrink: 0;
  color: var(--accent-color);
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/OrderModal/OrderModal.module.scss","webpack://./src/components/Assets/FileDropzone/FileDropzone.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;ACCF;ADEI;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;ACAN;ADEM;EACE,kBAAA;EACA,YAAA;ACAR;ADGM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;ACDR;ADGQ;EACE,gBAAA;ACDV;ADMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACJN;ADMM;EALF;IAMI,SAAA;ECHN;AACF;ADOM;EACE,iBAAA;EACA,YAAA;ACLR;ADUE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ACRJ;ADWE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ACTJ;ADUI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;ACRN;ADUI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;ACRN;ADYE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;ACVJ;ADaM;EACE,YAAA;ACXR;ADaU;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ACXZ;ADaY;EACE,mBAAA;EACA,UAAA;ACXd;ADgBQ;EACE,WAAA;ACdV;ADeU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;ACbZ;ADoBE;EACE,4BAAA;AClBJ;ADqBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;EACA,eAAA;ACnBJ;ADqBI;EACE,YAAA;ACnBN;ADsBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;ACpBJ;ADsBI;EANF;IAOI,mBAAA;ECnBJ;AACF;ADsBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;ACpBJ;ADsBI;EANF;IAOI,eAAA;ECnBJ;AACF;ADqBI;EAVF;IAWI,uBAAA;IACA,yBAAA;EClBJ;AACF;ADoBI;EACE,0BAAA;AClBN;ADsBE;EACE,cAAA;ACpBJ;ADuBE;EACE,aAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;ACrBJ;ADwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACtBJ;ADuBI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;ACrBN;ADuBI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ACrBN;ADyBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;ACvBJ;AD0BE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACxBJ;AD2BE;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC1BJ;AD2BI;EACE,YAAA;ACzBN;AD6BE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AC3BJ;AD8BE;EACE,WAAA;EACA,kBAAA;AC5BJ;AD8BI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AC5BN;AD8BM;EAPF;IAQI,WAAA;IACA,WAAA;IACA,YAAA;EC3BN;AACF;AD6BM;EAbF;IAcI,WAAA;IACA,YAAA;IACA,WAAA;EC1BN;AACF;AD6BI;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AC3BN;AD8BI;;;;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AC5BN;AD+BK;EACC,wBAAA;EACA,6BAAA;AC7BN;ADiCI;;EAEE,0BAAA;EACA,cAAA;EACA,WAAA;AC/BN;ADmCI;;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ACjCN;ADsCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ACpCN;ADsCM;EAbF;IAcI,YAAA;IACA,kBAAA;IACA,eAAA;ECnCN;AACF;ADqCM;EAnBF;IAoBI,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;EClCN;AACF;ADoCM;EACE,cAAA;AClCR;ADuCM;EACE,WAAA;ACrCR;AD0CE;EAIE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AC3CJ;AD8CE;EACE,UAAA;EACA,gBAAA;AC5CJ;AD+CE;EACE,UAAA;EACA,gBAAA;AC7CJ;ADgDE;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AC9CJ;ADiDE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;AC/CJ;ADgDI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AC9CN;ADiDI;EACE,kBAAA;EACA,YAAA;EACA,wBAAA;AC/CN;ADmDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ACjDJ;ADoDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AClDJ;ADqDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;ACnDJ;ADqDI;EACE,0BAAA;EACA,0BAAA;ACnDN;ADqDI;EACE,SAAA;EACA,UAAA;EACA,kBAAA;ACnDN;ADsDI;EACE,eAAA;ACpDN;ADsDI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;ACpDN;ADuDI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ACrDN;ADwDI;EACE,gBAAA;ACtDN;ADyDI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;ACvDN;AD0DI;EACE,gBAAA;ACxDN;AD2DI;EAGE,cAAA;AC3DN;AD6DI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AC3DN;AD6DI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AC3DN;AD+DE;EACE,gBAAA;AC7DJ;ADiEQ;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AC/DV;ADiEU;EACE,WAAA;EACA,YAAA;AC/DZ;ADsEE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;ACpEJ;ADsEI;EACE;IACE,iCAAA;ECpEN;AACF;ADwEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6BAAA;ACtEJ;ADwEI;EACE,eAAA;EACA,eAAA;ACtEN;AD2EI;EACE,WAAA;EACA,mBAAA;ACzEN;AD6EE;EACE,uBAAA;EACA,yBAAA;AC3EJ;AD8EE;EACE,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AC5EJ;AD+EE;EACE,iBAAA;EACA,mBAAA;AC7EJ;ADgFE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC9EJ;ADgFE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AC9EJ;ADiFI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AC/EN;ADkFI;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AChFN;ADoFE;EACE,iBAAA;AClFJ;ADqFE;EAKQ;IACE,YAAA;ECvFV;EDwFU;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;IACA,YAAA;ECtFZ;EDwFY;IACE,mBAAA;IACA,UAAA;ECtFd;ED8FE;IACE,oBAAA;EC5FJ;ED+FE;IACE,aAAA;IACA,kBAAA;EC7FJ;EDiGI;IACE,eAAA;EC/FN;EDkGI;IACE,eAAA;IACA,uBAAA;EChGN;EDoGE;IACE,gBAAA;EClGJ;EDqGE;IACE,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;ECnGJ;EDsGE;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;ECpGJ;EDuGE;IAEE,WAAA;IACA,YAAA;ECtGJ;EDuGI;IACE,WAAA;IACA,YAAA;ECrGN;AACF;ADwGE;EACE,qBAAA;ACtGJ;ADyGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ACvGJ;;AD2GA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;ACxGF;AD0GE;EANF;IAOI,qCAAA;ECvGF;AACF;ADyGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8CAAA;ACvGJ;ADyGI;EACE,yBAAA;ACvGN;AD2GE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACzGJ;AD4GE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AC1GJ;AD4GI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AC1GN;AD8GE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AC5GJ;ADiHI;EAFF;IAGI,aAAA;EC9GJ;AACF;ADgHI;EANF;IAOI,aAAA;EC7GJ;AACF;ADgHE;EACE,0CAAA;AC9GJ;ADiHE;EACE,4BAAA;EACA,sCAAA;AC/GJ;ADkHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AChHJ;ADkHI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AChHN;ADmHI;EACE,kBAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;ACjHN;ADqHE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;ACnHJ;ADqHI;EACE,WAAA;EACA,UAAA;EACA,wCAAA;EACA,wBAAA;EACA,mCAAA;EACA,iCAAA;ACnHN;ADqHM;EACE,aAAA;ACnHR;ADwHE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,0CAAA;EACA,UAAA;ACtHJ;ADyHI;EACE,WAAA;EACA,UAAA;EACA,wCAAA;EACA,wBAAA;EACA,mCAAA;EACA,iCAAA;ACvHN;ADyHM;EACE,aAAA;ACvHR;;AD6HA;EACE;IACE,QAAA;EC1HF;ED6HA;IACE,QAAA;EC3HF;ED8HA;IACE,QAAA;EC5HF;AACF;ADgIE;EADF;IAEI,2BAAA;IACA,yBAAA;IACA,eAAA;EC7HF;AACF;ADgII;EADF;IAEI,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;EC7HJ;AACF;;ADsIU;EADF;IAEI,cAAA;EClIV;AACF;;ADyIA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;ACtIF;;ADyIA;EACE,aAAA;EACA,sBAAA;ACtIF;ADwIE;EAJF;IAKI,SAAA;ECrIF;AACF;;ADwIA;EACE,kBAAA;ACrIF;ADuIE;EACE,kBAAA;EACA,2BAAA;EACA,SAAA;ACrIJ;ADuII;EALF;IAMI,kBAAA;IACA,SAAA;IACA,OAAA;IACA,2BAAA;IACA,SAAA;ECpIJ;AACF;;ADwIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;ACrIF;ADuIE;EACE,iBAAA;ACrIJ;ADwIE;EACE,WAAA;EACA,YAAA;ACtIJ;ADwII;EACE,aAAA;ACtIN;;AD2IA;EACE,kBAAA;ACxIF;AD0IE;EACE,gBAAA;ACxIJ;AD2IE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;ACzIJ;;AAp0BA;EACI,kBAAA;AAu0BJ;AAr0BI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,8CAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;AAu0BR;AAr0BQ;EACE;IACE,iCAAA;EAu0BV;AACF;AAp0BQ;EACI,qBAAA;AAs0BZ;AAl0BI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;AAo0BR;AAl0BQ;EACE;IACE,mBAAA;EAo0BV;AACF;AAh0BI;EACI,cAAA;EACA,0BAAA;EACA,kBAAA;AAk0BR","sourcesContent":[".orderModal {\n  padding: 0;\n\n  :global {\n    .modal__inner {\n      border-radius: 0;\n      max-width: none;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n      overflow: hidden;\n\n      .modal__header {\n        padding: 24px 16px;\n        border: none;\n      }\n\n      .modal__body {\n        background: #FFF;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        overflow: auto;\n        padding: 0;\n\n        .submitBlock {\n          margin-top: auto;\n        }\n      }\n    }\n\n    .options-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      @media (max-width: 1200px) {\n        gap: 24px;\n      }\n    }\n\n    .checkbox-row, .radio-row {\n      p {\n        line-height: 114%;\n        border: none;\n      }\n    }\n  }\n\n  .modal-text {\n    font-size: 14px;\n    line-height: 20px;\n    color: #54575C;\n  }\n\n  &__swipeHandler {\n    position: absolute;\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    height: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    span {\n      border-radius: 8px;\n      background: #FFF;\n      width: 88px;\n      height: 2px;\n      z-index: 2;\n      display: block;\n      position: relative;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      bottom: -5vh;\n      left: 0;\n      right: 0;\n      width: 100%;\n      height: 30vh;\n      background: transparent;\n    }\n  }\n\n  &__top {\n    width: 100%;\n    min-height: 216px;\n    height: 55vw;\n    max-height: 420px;\n    border-radius: 16px 16px 0 0;\n    overflow: hidden;\n\n    :global {\n      .swiper {\n        height: 100%;\n        &-pagination {\n          &-bullet {\n            width: 6px;\n            height: 6px;\n            margin: 0 6px;\n            background: #D9D9D9;\n            opacity: 0.4;\n\n            &-active {\n              background: #FAFAFA;\n              opacity: 1;\n            }\n          }\n        }\n\n        &-slide {\n          width: 100%;\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            object-position: center;\n          }\n        }\n      }\n    }\n  }\n\n  &__roundedTop {\n    border-radius: 16px 16px 0 0;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    border-radius: 16px 16px 0 0;\n    padding: 0 16px;\n\n    &_load {\n      gap: initial;\n    }\n  }\n  &__block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 5px;\n\n    @media (min-width: 1200px) {\n      margin-bottom: 24px;\n    }\n  }\n\n  &__blockTitle {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 114%;\n    padding-bottom: 4px;\n\n    @media (min-width: 640px) {\n      font-size: 22px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n    }\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  &__blockRequired {\n    color: #f2200d;\n  }\n\n  &__submitBlock {\n    padding: 16px;\n    bottom: -1px;\n    left: 50%;\n    background: #FFF;\n    z-index: 2;\n    position: sticky;\n    width: 100%;\n  }\n\n  &__submitBlockHead {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    h5 {\n      color: #151B26;\n      line-height: 114%;\n      font-size: 14px;\n      font-weight: 600;\n    }\n    p {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 114%;\n      letter-spacing: -0.24px;\n    }\n  }\n\n  &__submitBlockBottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 12px;\n  }\n\n  &__calc {\n    height: 44px;\n    width: 88px;\n    min-width: 88px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    background: #EEE;\n    margin-right: 12px;\n  }\n\n  &__calcPlus,\n  &__calcMinus {\n    width: 16px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n\n  &__calcNum {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    color: #000;\n    width: 32px;\n    margin: 0 4px;\n    text-align: center;\n  }\n\n  &__picker {\n    width: 100%;\n    position: relative;\n\n    img {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 10px;\n      pointer-events: none;\n\n      @media (min-width: 640px) {\n        right: 20px;\n        width: 32px;\n        height: 32px;\n      }\n\n      @media (min-width: 1200px) {\n        width: 22px;\n        height: 22px;\n        right: 10px;\n      }\n    }\n\n    input[type=\"date\"]:not(.has_value)::-webkit-datetime-edit-fields-wrapper,\n    input[type=\"datetime-local\"]:not(.has_value)::-webkit-datetime-edit-fields-wrapper {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n    input[type=\"date\"]::-webkit-inner-spin-button,\n    input[type=\"datetime-local\"]::-webkit-inner-spin-button,\n    input[type=\"date\"]::-webkit-calendar-picker-indicator,\n    input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n     input[type=\"date\"], input[type=\"datetime-local\"] {\n      -webkit-appearance: none;\n      width: -webkit-fill-available;\n     }\n\n    // Отображение placeholder у инпутов с типом даты\n    input[type=\"date\"]:not(.has_value):before, \n    input[type=\"datetime-local\"]:not(.has_value):before {\n      content: attr(placeholder);\n      color: #BEC0C2;\n      width: 100%;\n    }\n\n    // Блок для закрытия стрелки на мобилках\n    input[type=\"date\"]::after,\n    input[type=\"datetime-local\"]::after {\n      position: absolute;\n      right: 0;\n      content: \"\";\n      width: 20px;\n      height: 100%;\n      background: white;\n      border-radius: 8px;\n    }\n\n  \n\n    input {\n      width: 100%;\n      height: 40px;\n      border-radius: 8px;\n      border: 1px solid #E8ECEE;\n      background: #FFF;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px;\n      padding: 3px 10px;\n      position: relative;\n\n      @media (min-width: 640px) {\n        height: 64px;\n        padding-left: 32px;\n        font-size: 20px;\n      }\n\n      @media (min-width: 1200px) {\n        height: 38px;\n        padding-left: 10px;\n        font-size: var(--fz-md);\n        line-height: normal;\n      }\n\n      &::placeholder {\n        color: #BEC0C2;\n      }\n    }\n\n    :global {\n      .react-datepicker-wrapper {\n        width: 100%;\n      }\n    }\n  }\n\n  &__sk1,\n  &__sk2,\n  &__sk3,\n  &__sk4 {\n    border-radius: 2px;\n    height: 13px;\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  &__sk2 {\n    width: 85%;\n    margin-top: 10px;\n  }\n\n  &__sk3 {\n    width: 50%;\n    margin-top: 10px;\n  }\n\n  &__sk4 {\n    width: 20%;\n    margin-top: 16px;\n    margin-bottom: 9px;\n  }\n\n  &__sk5 {\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #F3F2F2;\n    span {\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      display: block;\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n\n    div {\n      border-radius: 2px;\n      height: 14px;\n      width: calc(100% - 34px);\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__infoTitle {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    color: var(--text-color);\n  }\n\n  &__infoText {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    word-wrap: break-word;\n\n    a {\n      color: var(--accent-color);\n      text-decoration: underline;\n    }\n    ul, ol{\n      margin: 0;\n      padding: 0;\n      padding-left: 16px;\n    }\n\n    img {\n      max-width: 100%;\n    }\n    table {\n      border-collapse: collapse;\n      table-layout: fixed;\n      width: 100%;\n      margin: 0;\n      overflow: hidden\n    }\n\n    table td,table th {\n      min-width: 1em;\n      border: 2px solid #ced4da;\n      padding: 3px 5px;\n      vertical-align: top;\n      box-sizing: border-box;\n      position: relative\n    }\n\n    table td>*,table th>* {\n      margin-bottom: 0\n    }\n\n    table th {\n      font-weight: 700;\n      text-align: left;\n      background-color: #f1f3f5\n    }\n\n    p {\n      min-height: 20px;\n    }\n\n    & h1,\n    & h2,\n    & h3 {\n      color: #303030;\n    }\n    pre {\n      background: #2b2a2a;\n      color: #fff;\n      padding: 8px;\n      display: flex;\n      border-radius: 8px;\n      width: 100%;\n      white-space: pre-wrap;\n    }\n    code {\n      width: 100%;\n      display: block;\n      color: #fff;\n      background-color: #f1f3f5;\n    }\n  }\n\n  &__files {\n    padding-top: 8px;\n\n    :global {\n      .orderModal {\n        &__file {\n          flex-direction: row;\n          flex-wrap: nowrap;\n          padding: 8px 32px 8px 4px;\n          border-radius: 12px;\n          border: 1px solid transparent;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          position: relative;\n          transition: var(--transition);\n          margin-bottom: 8px;\n\n          img {\n            width: 15px;\n            height: 21px;\n          }\n        }\n      }\n    }\n  }\n\n  &__file {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 2px;\n    margin-bottom: 8px;\n    padding: 8px 32px 8px 4px;\n    background: var(--white);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    position: relative;\n    transition: var(--transition);\n\n    @media (hover: hover) {\n      &:hover {\n        border-color: var(--accent-color);\n      }\n    }\n  }\n\n  &__fileContent {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: var(--transition);\n\n    img {\n      max-width: 24px;\n      min-width: 24px;\n    }\n  }\n\n  &__fileIsLoading {\n    &__loader {\n      height: 3px;\n      background: #4084F8;\n    }\n  }\n\n  &__fileName {\n    font-size: var(--fz-md);\n    line-height: var(--lh-md);\n  }\n\n  &__fileSize {\n    font-size: var(--fz-sm);\n    line-height: 1;\n    color: #7A808B;\n    margin-top: 2px;\n  }\n\n  &__fileDelete {\n    margin-left: auto;\n    color: var(--error);\n  }\n\n  &__object {\n    border-radius: 12px;\n    background: #FAFAFA;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n  }\n  &__objectIco {\n    width: 26px;\n    min-width: 26px;\n    height: 26px;\n    margin-right: 8px;\n  }\n  &__objectText {\n    span {\n      font-size: 14px;\n      line-height: 114%;\n      color: #7A808B;\n    }\n\n    p {\n      font-size: 16px;\n      color: #101618;\n      line-height: 23.04px;\n    }\n  }\n\n  &__objectArrow {\n    margin-left: auto;\n  }\n\n  @media (min-width: 640px) {\n\n    &__top {\n      :global {\n        .swiper {\n          &-pagination {\n            bottom: 24px;\n            &-bullet {\n              width: 12px;\n              height: 12px;\n              margin: 0 12px;\n              background: #D9D9D9;\n              opacity: 0.4;\n    \n              &-active {\n                background: #FAFAFA;\n                opacity: 1;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &__body {\n      padding: 16px 24px 0;\n    }\n\n    &__submitBlock {\n      padding: 24px;\n      margin-left: -24px;\n    }\n\n    &__submitBlockHead {\n      h5 {\n        font-size: 32px;\n      }\n\n      p {\n        font-size: 28px;\n        letter-spacing: -0.56px;\n      }\n    }\n\n    &__submitBlockBottom {\n      margin-top: 18px;\n    }\n\n    &__calc {\n      border-radius: 16px;\n      width: 195px;\n      min-width: 195px;\n      height: 76px;\n      margin-right: 16px;\n    }\n\n    &__calcNum {\n      width: 59px;\n      height: 22px;\n      margin: 0 16px;\n      font-size: 28px;\n    }\n\n    &__calcPlus,\n    &__calcMinus {\n      width: 32px;\n      height: 32px;\n      svg {\n        width: 32px;\n        height: 32px;\n      }\n    }\n  }\n  &__inputError.orderModal__inputError{\n    border-color: #F2200D;\n  }\n\n  &__time {\n    font-size: 12px;\n    padding: 2px 4px;\n    min-height: auto;\n  }\n}\n\n.photoBlock {\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: repeat(3, 1fr);\n  position: relative;\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  &__append {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    height: 105px;\n    cursor: pointer;\n    background: rgba(var(--accent-color-rgb), 0.1);\n\n    &.error {\n      border: 1px solid #F2200D;\n    }\n  }\n\n  &__plus {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: var(--accent-color);\n    color: var(--accent-text-color);\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__preview {\n    height: 105px;\n    border-radius: 8px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    &>img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  &__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    background: #E97676;\n  }\n\n  &__append,\n  &__preview {\n    @media (min-width: 640px) {\n      height: 140px;\n    }\n\n    @media (min-width: 1200px) {\n      height: 104px;\n    }\n  }\n\n  &__camera {\n    color: rgba(var(--accent-color-rgb), 0.45)\n  }\n\n  &__error {\n    position: initial !important;\n    justify-content: flex-start !important;\n  }\n\n  &__loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &__precent {\n      color: white;\n      font-weight: 600;\n      font-size: 12px;\n      z-index: 1;\n    }\n\n    &__overlay {\n      position: absolute;\n      background: #b2b2b2ad;\n      width: 100%;\n      height: 100%;\n      top: 0;\n    }\n  }\n\n  &__compressBlock {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    width: 60px;\n    height: 60px;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 1;\n\n    svg {\n      width: 24px;\n      fill: none;\n      animation-name: grow;\n      animation-duration: 1.5s;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n\n      path {\n        stroke: white;\n      }\n    }\n  }\n\n  &__compressLoading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(255,255,255, 0.8);\n    z-index: 3;\n\n\n    svg {\n      width: 24px;\n      fill: none;\n      animation-name: grow;\n      animation-duration: 1.5s;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n\n      path {\n        stroke: black;\n      }\n    }\n  }\n}\n\n@keyframes grow {\n  0% {\n    scale: (1);\n  }\n\n  50% {\n    scale: (2);\n  }\n\n  100% {\n    scale: (1);\n  }\n}\n\nlabel.checkboxAlone {\n  @media (min-width: 1200px) {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    padding-left: 0;\n  }\n\n  p {\n    @media (min-width: 1200px) {\n      width: auto;\n      font-weight: 500;\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n      padding-top: 5px;\n      margin-right: 8px;\n    }\n  }\n}\n\n.orderModal {\n  &__block {\n    .checkboxAlone {\n      p {\n        &:last-child {\n          @media (min-width: 1200px) {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.conditionList {\n  position: initial;\n  overflow: hidden;\n  transition: 0.15s;\n}\n\n.conditionList__container {\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n}\n\n.qrWrapBlock {\n  position: relative;\n\n  .qrWrapBlock__error {\n    position: relative;\n    justify-content: flex-start;\n    margin: 0;\n\n    @media (min-width: 1200px) {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      justify-content: flex-start;\n      margin: 0;\n    }\n  }\n}\n\n.qrBlock {\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #EAF7EF;\n  width: max-content;\n  cursor: pointer;\n\n  &--error {\n    color: var(--red);\n  }\n\n  svg {\n    width: 13px;\n    height: 13px;\n\n    path {\n      fill: #2DBE64;\n    }\n  }\n}\n\n.QRInput {\n  position: relative;\n\n  input:disabled {\n    background: none;\n  }\n\n  &__icon {\n    position: absolute;\n    top: calc(50% - 16px);\n    right: 10px;\n    background: none;\n  }\n}","@import \"../../Modals/OrderModal/OrderModal.module.scss\";\n\n.fileDropzone {\n    position: relative;\n\n    &__append {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        align-self: flex-start;\n        font-size: var(--fz-md);\n        font-style: normal;\n        font-weight: 400;\n        line-height: var(--lh-md);\n        color: #000;\n        padding: 10px;\n        border-radius: 8px;\n        border: 1px solid transparent;\n        background: rgba(var(--accent-color-rgb), 0.1);\n        cursor: pointer;\n        transition: var(--transition);\n        min-height: 40px;\n\n        @media (hover: hover) {\n          &:hover {\n            border-color: var(--accent-color);\n          }\n        }\n\n        &.error {\n            border-color: #F2200D;\n        }\n    }\n\n    &__delete {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 14px;\n        width: 16px;\n        height: 16px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #ABB8C8;\n        transition: var(--transition);\n\n        @media (hover: hover) {\n          &:hover {\n            color: var(--error);\n          }\n        }\n    }\n\n    &__plus {\n        flex-shrink: 0;\n        color: var(--accent-color);\n        margin-right: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderModal": `FileDropzone_orderModal__G+LCe`,
	"modal-text": `FileDropzone_modal-text__HsFjP`,
	"orderModal__swipeHandler": `FileDropzone_orderModal__swipeHandler__0jG38`,
	"orderModal__top": `FileDropzone_orderModal__top__n38Ki`,
	"orderModal__roundedTop": `FileDropzone_orderModal__roundedTop__svAsM`,
	"orderModal__body": `FileDropzone_orderModal__body__Unjg7`,
	"orderModal__body_load": `FileDropzone_orderModal__body_load__v38gi`,
	"orderModal__block": `FileDropzone_orderModal__block__Xi6Ht`,
	"orderModal__blockTitle": `FileDropzone_orderModal__blockTitle__SZUzg`,
	"orderModal__blockRequired": `FileDropzone_orderModal__blockRequired__6gUgW`,
	"orderModal__submitBlock": `FileDropzone_orderModal__submitBlock__6JHiY`,
	"orderModal__submitBlockHead": `FileDropzone_orderModal__submitBlockHead__CjzUd`,
	"orderModal__submitBlockBottom": `FileDropzone_orderModal__submitBlockBottom__VP6KD`,
	"orderModal__calc": `FileDropzone_orderModal__calc__AgiV0`,
	"orderModal__calcPlus": `FileDropzone_orderModal__calcPlus__M0+Om`,
	"orderModal__calcMinus": `FileDropzone_orderModal__calcMinus__oY4XJ`,
	"orderModal__calcNum": `FileDropzone_orderModal__calcNum__KAa+D`,
	"orderModal__picker": `FileDropzone_orderModal__picker__er0sV`,
	"has_value": `FileDropzone_has_value__6CTbY`,
	"orderModal__sk1": `FileDropzone_orderModal__sk1__P1ht4`,
	"orderModal__sk2": `FileDropzone_orderModal__sk2__AIszX`,
	"orderModal__sk3": `FileDropzone_orderModal__sk3__UOVJm`,
	"orderModal__sk4": `FileDropzone_orderModal__sk4__fDmeU`,
	"orderModal__sk5": `FileDropzone_orderModal__sk5__IMPO0`,
	"orderModal__info": `FileDropzone_orderModal__info__99NRu`,
	"orderModal__infoTitle": `FileDropzone_orderModal__infoTitle__ep0eT`,
	"orderModal__infoText": `FileDropzone_orderModal__infoText__hhRbt`,
	"orderModal__files": `FileDropzone_orderModal__files__ykQop`,
	"orderModal__file": `FileDropzone_orderModal__file__IZTOX`,
	"orderModal__fileContent": `FileDropzone_orderModal__fileContent__CubJ8`,
	"orderModal__fileIsLoading__loader": `FileDropzone_orderModal__fileIsLoading__loader__8xxOk`,
	"orderModal__fileName": `FileDropzone_orderModal__fileName__N4Co4`,
	"orderModal__fileSize": `FileDropzone_orderModal__fileSize__u+7-m`,
	"orderModal__fileDelete": `FileDropzone_orderModal__fileDelete__G0yhs`,
	"orderModal__object": `FileDropzone_orderModal__object__Bzw9F`,
	"orderModal__objectIco": `FileDropzone_orderModal__objectIco__mTs2F`,
	"orderModal__objectText": `FileDropzone_orderModal__objectText__nbCWv`,
	"orderModal__objectArrow": `FileDropzone_orderModal__objectArrow__X5W2r`,
	"orderModal__inputError": `FileDropzone_orderModal__inputError__JXW4v`,
	"orderModal__time": `FileDropzone_orderModal__time__fCEw7`,
	"photoBlock": `FileDropzone_photoBlock__+APaP`,
	"photoBlock__append": `FileDropzone_photoBlock__append__shBAv`,
	"error": `FileDropzone_error__qAZKX`,
	"photoBlock__plus": `FileDropzone_photoBlock__plus__yTF4O`,
	"photoBlock__preview": `FileDropzone_photoBlock__preview__oGY-g`,
	"photoBlock__close": `FileDropzone_photoBlock__close__Q8jY-`,
	"photoBlock__camera": `FileDropzone_photoBlock__camera__MlRXJ`,
	"photoBlock__error": `FileDropzone_photoBlock__error__G4eGh`,
	"photoBlock__loader": `FileDropzone_photoBlock__loader__DRSg+`,
	"photoBlock__loader__precent": `FileDropzone_photoBlock__loader__precent__c4k9o`,
	"photoBlock__loader__overlay": `FileDropzone_photoBlock__loader__overlay__vRbP7`,
	"photoBlock__compressBlock": `FileDropzone_photoBlock__compressBlock__ov0nA`,
	"grow": `FileDropzone_grow__kkSg9`,
	"photoBlock__compressLoading": `FileDropzone_photoBlock__compressLoading__z-ZiA`,
	"checkboxAlone": `FileDropzone_checkboxAlone__dxA8B`,
	"conditionList": `FileDropzone_conditionList__2AeRA`,
	"conditionList__container": `FileDropzone_conditionList__container__O38hp`,
	"qrWrapBlock": `FileDropzone_qrWrapBlock__-RSlE`,
	"qrWrapBlock__error": `FileDropzone_qrWrapBlock__error__8kcQT`,
	"qrBlock": `FileDropzone_qrBlock__Uew+L`,
	"qrBlock--error": `FileDropzone_qrBlock--error__-uN80`,
	"QRInput": `FileDropzone_QRInput__VlEEA`,
	"QRInput__icon": `FileDropzone_QRInput__icon__S2e4i`,
	"fileDropzone": `FileDropzone_fileDropzone__0XYHQ`,
	"fileDropzone__append": `FileDropzone_fileDropzone__append__QvP1E`,
	"fileDropzone__delete": `FileDropzone_fileDropzone__delete__UKrh0`,
	"fileDropzone__plus": `FileDropzone_fileDropzone__plus__CoCc9`
};
export default ___CSS_LOADER_EXPORT___;
